import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import EmptyData from 'components/EmptyData';
import { DateTime } from 'luxon';

import EmptyCalendarSvg from '@common/assets/icons/empty-data-calendar.svg';
import { IClientGradeBookModel } from '@common/models/ClientGradeBook/ClientGradeBook';

import WeekDayView from '../WeekDayView';
import { StyledGradeBookWeekWrap } from './styled';

interface GradeBookWeekProps {
	days: Record<string, IClientGradeBookModel[]>;
	onSelectLesson?: (lesson: IClientGradeBookModel) => void;
}

function WeekView({ days, onSelectLesson }: GradeBookWeekProps) {
	const { t } = useTranslation();
	if (!days) {
		return (
			<EmptyData
				icon={<EmptyCalendarSvg />}
				title={t('gradeBook.emptyTitle')}
				subTitle={t('gradeBook.emptyDescription')}
			/>
		);
	}

	return (
		<StyledGradeBookWeekWrap>
			{Object.entries(days).map(([date, gradeBooks]) => (
				<WeekDayView
					gradeBooks={gradeBooks}
					key={date}
					day={DateTime.fromISO(date)}
					onSelectLesson={onSelectLesson}
				/>
			))}
		</StyledGradeBookWeekWrap>
	);
}

export default observer(WeekView);
